import { DatePicker, FormInstance, Input } from 'antd'
import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'
import { useRFITrackerContext } from '../../../../../../../RFITrackerContext'
import CIMSSelect from 'components/CIMSSelect'
import { useOptions } from 'components/CIMSSelect/hooks/useOptions'
import { alphabeticalCompare } from '@cims-online/shared'
import CIMSComment from 'components/CIMSComment'
import { useWorkflowRollbackComment } from 'components/CIMSComment/hooks/useWorkflowRollbackComment'
import { RequestForInformation } from '../../../../../../../RFITrackerContext/types'

const Help = HelpMessage.RequestsForInformation.RFITracker

export const PendingResponsesFormItems: React.FC<
  Partial<RequestForInformation> & {
    form: FormInstance
  }
> = ({ responseDisciplines, form }) => {
  const {
    metadata,
    selectOptions: { organizationOptions },
  } = useRFITrackerContext()
  const closedIds = responseDisciplines?.map(({ id }) => id)
  const reopenDisciplinesOptions = useOptions({
    items: responseDisciplines,
    label: 'name',
    value: 'id',
    sort: (a, b) => alphabeticalCompare(a.name, b.name),
    tooltip: ({ description }) => description,
  })
  const additionalDisciplineOptions = useOptions({
    items: metadata?.rfiResponseDisciplines?.filter(
      ({ id }) => !closedIds?.includes(id)
    ),
    label: 'name',
    value: 'id',
    sort: (a, b) => alphabeticalCompare(a.name, b.name),
    tooltip: ({ description }) => description,
  })
  return (
    <>
      <CIMSFormItem
        name="description"
        label="Description"
        requiredMessage="Please enter a description"
        help={HelpMessage.Description('Request For Information')}
      >
        <Input />
      </CIMSFormItem>
      <CIMSFormItem
        name="organizationId"
        label="Submitting Organization"
        requiredMessage="Please select an organization"
        help={Help.Organization}
      >
        <CIMSSelect simple options={organizationOptions} />
      </CIMSFormItem>
      <CIMSFormItem
        name="requestedResponseDate"
        label="Requested Response Date"
        requiredMessage="Please pick a requested response date"
        help={Help.ResponseDate}
      >
        <DatePicker allowClear />
      </CIMSFormItem>
      <CIMSFormItem
        name="reopenDisciplineIds"
        label="Reopen Disciplines"
        customValidator={{
          validator: (value) =>
            !!value?.length ||
            !!form.getFieldValue('additionalDisciplineIds')?.length,
          message: 'Must reopen or add at least one discipline',
        }}
        help={Help.ReopenDisciplines}
      >
        <CIMSSelect simple mode="multiple" options={reopenDisciplinesOptions} />
      </CIMSFormItem>
      <CIMSFormItem
        name="additionalDisciplineIds"
        label="Add Disciplines"
        customValidator={{
          validator: (value) =>
            !!value?.length ||
            !!form.getFieldValue('reopenDisciplineIds')?.length,
          message: 'Must reopen or add at least one discipline',
        }}
        help={Help.AddDisciplines}
      >
        <CIMSSelect
          simple
          mode="multiple"
          // have to do this to prevent allowClear from clearing disabled options
          allowClear={false}
          options={additionalDisciplineOptions}
          onChange={() =>
            form.validateFields([
              'reopenDisciplineIds',
              'additionalDisciplineIds',
            ])
          }
        />
      </CIMSFormItem>
      <CIMSFormItem {...useWorkflowRollbackComment()}>
        <CIMSComment />
      </CIMSFormItem>
    </>
  )
}
